import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe, TitleCasePipe } from '@angular/common';
import { RemoveInactivesPipe } from './removeInactivePipe/removeInactive.pipe';
import { OrderVesselImagesByPipe } from './order-vessel-images-by.pipe';
import { PayoutDisplayNamePipe } from './payout-display-name.pipe';
import { VesselRateDisplayNamePipe } from './vessel-rate-display-name.pipe';
import { KebabCasePipe } from './kebabCase.pipe';
import { MilitaryTimeToStringPipe } from './military-to-string.pipe';
import { OrderVesselsByModule } from './order-vessels-by/order-vessels-by.module';
import { RoundDownPipe } from './roundDown.pipe';
import { PhonePipe } from './phone/phone.pipe';

@NgModule({
  declarations: [
    RemoveInactivesPipe,
    OrderVesselImagesByPipe,
    PayoutDisplayNamePipe,
    VesselRateDisplayNamePipe,
  ],
  imports: [CommonModule],
  exports: [
    RemoveInactivesPipe,
    OrderVesselImagesByPipe,
    PayoutDisplayNamePipe,
    VesselRateDisplayNamePipe,
    CommonModule,
  ],
  providers: [
    OrderVesselImagesByPipe,
    PayoutDisplayNamePipe,
    KebabCasePipe,
    MilitaryTimeToStringPipe,
    VesselRateDisplayNamePipe,
    PhonePipe,
    TitleCasePipe,
    RoundDownPipe,
    DecimalPipe,
  ],
})
export class MainPipe {}
